// extracted by mini-css-extract-plugin
module.exports = {"defaultIconStyle":"az_gk","fontSizeInherit":"az_hk","fontSizeSmall":"az_ik","fontSizeLarge":"az_jk"};